module.exports = __webpack_public_path__ + "img/0Q3B7166.d63bdb11.webp";